import request from '@/utils/request'

export function uploadFile(data) {
  return request({
    url: 'HuiTianUpload/uploadFile',
    method: 'post',
    data,
  })
}

export function uploadFileWithName(data) {
  return request({
    url: 'HuiTianUpload/uploadFileWithName',
    method: 'post',
    data
  })
}